'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _animateFadeDecorator = require('../animations/animateFadeDecorator');

var _animateFadeDecorator2 = _interopRequireDefault(_animateFadeDecorator);

var _LogoSpinner = require('./LogoSpinner');

var _LogoSpinner2 = _interopRequireDefault(_LogoSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PageLoaderQuote = (0, _animateFadeDecorator2.default)()(function (_ref) {
    var showQuote = _ref.showQuote,
        quoteText = _ref.quoteText,
        quoteAttribution = _ref.quoteAttribution;
    return _react2.default.createElement(
        'div',
        { className: 'loading-text' },
        quoteText ? _react2.default.createElement(
            'div',
            { className: 'loading-quote' },
            '\u201C',
            quoteText,
            '\u201D'
        ) : null,
        quoteAttribution ? _react2.default.createElement(
            'div',
            { className: 'loading-attr' },
            '\u2014',
            quoteAttribution
        ) : null
    );
});

PageLoaderQuote.propTypes = {
    quoteText: _propTypes2.default.string,
    quoteAttribution: _propTypes2.default.string
};

var PageLoaderMain = function PageLoaderMain(_ref2) {
    var logoAnimate = _ref2.logoAnimate,
        logoFade = _ref2.logoFade,
        logoShow = _ref2.logoShow,
        quoteShow = _ref2.quoteShow,
        quoteFade = _ref2.quoteFade,
        rest = _objectWithoutProperties(_ref2, ['logoAnimate', 'logoFade', 'logoShow', 'quoteShow', 'quoteFade']);

    return _react2.default.createElement(
        'div',
        { className: 'PageLoaderMain workspace-positioner' },
        _react2.default.createElement('div', { className: 'Toolbar' }),
        _react2.default.createElement(
            'main',
            { className: 'Main' },
            _react2.default.createElement(
                'div',
                { className: 'PageLoadingDisplay' },
                _react2.default.createElement(_LogoSpinner2.default, _extends({}, rest, {
                    animate: logoAnimate,
                    fadeIn: logoFade,
                    show: logoShow })),
                _react2.default.createElement(PageLoaderQuote, _extends({ fadeIn: quoteFade, show: quoteShow }, rest))
            )
        )
    );
};

PageLoaderMain.propTypes = {
    logoAnimate: _propTypes2.default.bool,
    logoFade: _propTypes2.default.bool,
    logoShow: _propTypes2.default.bool,

    quoteShow: _propTypes2.default.bool,
    quoteFade: _propTypes2.default.bool
};

exports.default = PageLoaderMain;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/loaders/PageLoaderMain.js
// module id = 439
// module chunks = 0